import { useEffect, useState } from "react";

import useWindowSize from "@/hooks/useWindowSize";

/**
 * Test whether the browser width satisfies a certain breakpoint
 *
 * USAGE
 *
 * To test whether the browser satisfies `@media(--md) { ... }`,
 * use it like this:
 *
 *
 * const isMd = useBreakpointTest("md");
 *
 *
 * To test whether the browser satisfies `@media(--mdMax) { ... }`,
 * use it like this:
 *
 *
 * const isMd = useBreakpointTest("md", "max");
 *
 *
 */

const useBreakpointTest = (
  breakpointKey: string,
  minMax: "min" | "max" = "min"
) => {
  const [windowWidth] = useWindowSize();
  const [isTrue, setIsTrue] = useState(false);
  const [breakpointWidth, setBreakpointWidth] = useState(0);

  // Get breakpoint width
  useEffect(() => {
    const breakpointWidth = getComputedStyle(
      document.documentElement
    ).getPropertyValue(`--${breakpointKey}`);
    setBreakpointWidth(parseInt(breakpointWidth));
  }, []);

  useEffect(() => {
    if (minMax === "min") {
      setIsTrue(windowWidth >= breakpointWidth);
      return;
    }
    setIsTrue(windowWidth < breakpointWidth);
  }, [windowWidth, breakpointWidth]);

  return isTrue;
};

export default useBreakpointTest;
